import authenticted from '../http-clients/authenticated'
import store from '@/store'

export default{
  index({tenantId, knowledgecheckId}){

    if(!tenantId){
      tenantId = store.tenants.current.id
    }

    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/responses`,
      method: 'get'
    })
  },

  store({tenantId,  knowledgecheckId, data}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/responses`,
      method: 'post',
      data
    })
  },

  show({tenantId,  knowledgecheckId, responseId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/responses/${responseId}`,
      method: 'get'
    })
  },

  destroy({tenantId,  knowledgecheckId, responseId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/responses/${responseId}`,
      method: 'delete'
    })
  },

  startAssigned({tenantId,  knowledgecheckId, responseId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/responses/${responseId}/start`,
      method: 'put'
    })
  },

  complete({tenantId,  knowledgecheckId, responseId}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/responses/${responseId}/complete`,
      method: 'put'
    })
  },

  answer({tenantId,  knowledgecheckId, responseId, questionId, data}){
    return authenticted({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}/responses/${responseId}/questions/${questionId}`,
      method: 'post',
      data
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/knowledgechecks/response.js